const PRICING_PLANS = [
  "5000 User Activities",
  "Unlimited Access",
  "No Hidden Charge",
  "03 Time Updates",
  "Figma Source File",
  "Many More Facilities",
];

export const PRICING_LIST_TWO = [
  {
    id: 1,
    isPopular: false,
    title: "Basic Plan",
    prices: { monthly: 19, yearly: 119 },
    plans: PRICING_PLANS,
    href: "/contact",
  },
  {
    id: 2,
    isPopular: true,
    title: "Team Plan",
    prices: { monthly: 49, yearly: 499 },
    plans: PRICING_PLANS,
    href: "/contact",
  },
  {
    id: 3,
    isPopular: false,
    title: "Enterprise Plan",
    prices: { monthly: 99, yearly: 999 },
    plans: PRICING_PLANS,
    href: "/contact",
  },
];

export const PRICING_LIST_THREE = [
  {
    id: 1,
    isPopular: false,
    title: "Basic Plan",
    prices: { monthly: 19, yearly: 119 },
    plans: PRICING_PLANS,
    href: "/contact",
    icon: "flaticon-rocket",
  },
  {
    id: 2,
    isPopular: true,
    title: "Team Plan",
    prices: { monthly: 39, yearly: 339 },
    plans: PRICING_PLANS,
    href: "/contact",
    icon: "flaticon-inspiration",
  },
  {
    id: 3,
    isPopular: false,
    title: "Enterprise Plan",
    prices: { monthly: 89, yearly: 899 },
    plans: PRICING_PLANS,
    href: "/contact",
    icon: "flaticon-briefcase-1",
  },
];

export const PRICING_LIST_ONE = [
  {
    id: 1,
    isPopular: false,
    title: "Basic Plan",
    prices: { monthly: 19, yearly: 119 },
    plans: PRICING_PLANS,
    href: "/contact",
  },
  {
    id: 2,
    isPopular: true,
    title: "Standard Plan",
    prices: { monthly: 39, yearly: 329 },
    plans: PRICING_PLANS,
    href: "/contact",
  },
  {
    id: 3,
    isPopular: false,
    title: "Business Plan",
    prices: { monthly: 99, yearly: 899 },
    plans: PRICING_PLANS,
    href: "/contact",
  },
];
